"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'OrderStatistics',
  components: {
    MerchantName: _merchantName.default
  },
  data: function data() {
    return {
      checkPermi: _permission.checkPermi,
      // 权限判断函数
      tableData: {
        // 订单列表数据
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        // 订单列表参数
        page: 1,
        limit: 10,
        orderNo: '',
        // 订单号
        merId: null,
        // 商户名称ID
        productName: '',
        // 商品名称
        skuName: '',
        // 规格名称
        status: 'all',
        // 订单状态
        dateLimit: '',
        // 提交日期
        payDateLimit: '',
        // 支付日期
        searchType: 'all',
        // 用户搜索类型 all-全部 uid-用户ID phone-手机号 nickname-用户昵称
        content: '' // 用户搜索
      },
      dateLimit: [],
      // 提交日期数据
      payDateLimit: [],
      // 支付日期数据
      card_select_show: false,
      // 列选择器显示
      checkAll: false,
      // 列显示-全选
      checkedCities: [
      // 列显示-已选
      '订单号', '商户名称', '用户昵称', '商品名称', '规格名称', '订单状态', '商品总价', '商品总数', '实际支付', '会员抵扣金额', '现金券支付金额', '平台优惠金额', '商户优惠金额', '佣金支付金额', '积分抵扣金额', '债权抵扣金额', '支付邮费', '债务化债金额', '助力化债金额', '购物返现金额', '赠送现金券额',
      // '赠送积分',
      '提交时间', '支付时间', '商品ID', '规格ID'],
      columnData: [
      // 列显示-列表
      '订单号', '商户名称', '用户昵称', '商品名称', '规格名称', '订单状态', '商品总价', '商品总数', '实际支付', '会员抵扣金额', '现金券支付金额', '平台优惠金额', '商户优惠金额', '佣金支付金额', '积分抵扣金额', '债权抵扣金额', '支付邮费', '债务化债金额', '助力化债金额', '购物返现金额', '赠送现金券额',
      // '赠送积分',
      '提交时间', '支付时间', '商品ID', '规格ID'],
      isIndeterminate: true,
      // 列显示-半选
      statusOptions: [
      // 订单状态
      {
        value: 'all',
        text: '全部'
      }, {
        value: 'unPaid',
        text: '未支付'
      }, {
        value: 'notShipped',
        text: '未发货'
      }, {
        value: 'spike',
        text: '待收货'
      }, {
        value: 'receiving',
        text: '已收货'
      }, {
        value: 'complete',
        text: '已完成'
      }, {
        value: 'refunded',
        text: '已退款'
      }, {
        value: 'deleted',
        text: '已删除'
      }, {
        value: 'awaitVerification',
        text: '待核销'
      }, {
        value: 'cancel',
        text: '已取消'
      }],
      exportLoading: false // 导出加载
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:order:page:list'])) this.getList();
  },
  methods: {
    // 商户名称选择
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.handleSearchList();
    },
    // 筛选重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dateLimit = [];
      this.payDateLimit = [];
      this.tableFrom.searchType = 'all';
      this.tableFrom.page = 1;
      this.handleSearchList();
    },
    // 筛选查询
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e, keyName) {
      this[keyName] = e;
      this.tableFrom[keyName] = e ? this[keyName].join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _order.getOrderStatisticsListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
        _this.checkedCities = _this.$cache.local.has('order_statistics_stroge') ? _this.$cache.local.getJSON('order_statistics_stroge') : _this.checkedCities;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 分页
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 导出
    exports: function exports() {
      var _this2 = this;
      this.exportLoading = true;
      (0, _order.orderStatisticsExcelApi)(this.tableFrom).then(function (res) {
        window.open(res.fileName);
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    // 操作-列显示
    handleAddItem: function handleAddItem() {
      console.log('操作-列显示');
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    // 列显示-全选
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    // 列显示-单个切换
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    // 列显示-保存
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_statistics_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};